var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pa-3"},[_c('h2',{staticClass:"mb-10"},[_vm._v("CSVダウンロード")]),_c('section',{staticClass:"bulk__upload_area col-7 mb-4"},[_c('v-btn',{attrs:{"rounded":"","outlined":""},on:{"click":_vm.csvDownload}},[_vm._v(" 写真情報をCSVで一括ダウンロードする ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }